<template>
  <v-dialog
    v-model="dialog"
    persistent
    :max-width="1000"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon color="primary">
          mdi-eye
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      :title="'Exam Results '+ '('+exam.name+')'"
      text="Exam Results"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row>
          <v-col
            class="py-0"
            cols="12"
          >
            <div class="align-header-switch">
              <h4 class="font-weight-bold">
                {{ resultTab? 'RESULT':'PENDING MARKING' }}
              </h4>
            
              <v-spacer />
              <v-switch
                v-model="resultTab"
                inset
                class="pt-0 mt-0"
                :label="resultTab? 'Result':'Marking'"
              />
            </div>
          </v-col>

          <v-col
            v-if="!loadingCompleted"
            cols="12"
            class="d-flex attempt-container-min-height"
          >
            <v-progress-circular
              indeterminate
              :size="50"
              color="primary"
              class="ma-auto"
            />
          </v-col>
          <v-col
            v-else
            cols="12"
            class="attempt-container-min-height"
          >
            <v-col
              v-if="!resultTab"
              cols="12"
            >
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="pendingSearchInput"
                    placeholder="Filter by name"
                    append-icon="search"
                    label="Search Candidate"
                    hide-no-data
                    hide-details
                    hide-selected
                  />
                </v-col>
                <v-col cols="6">
                  <v-menu
                    v-model="pendingDateMenu"
                    :close-on-content-click="true"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="pendingDate"
                        label="Attempt Date"
                        prepend-icon="search"      
                        readonly
                        hide-details
                        clearable
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="pendingDate"
                    />
                  </v-menu>
                </v-col>
              </v-row>
              
              <div class="scrollbar max-attempt-height px-1">
                <span v-if="filteredPendingAttempts.length < 1">No Pending Marking Attempts</span>
                <v-card
                  v-for="(item,index) of filteredPendingAttempts"
                  v-else
                  :key="index"
                  class="my-1"
                >
                  <v-row class="ml-1 full-width">
                    <v-col
                      class="font-weight-bold my-auto text-left py-0 name-ellipsis"
                      cols="4"
                    >
                      {{ item.employee.person.name }}
                    </v-col>

                    <v-col
                      cols="3"
                      class="ma-auto text-center py-0"
                      :class="{
                        'warning--text':!item.score
                      }"
                    >
                      {{ item.score ? item.score+'%':'Pending Marking' }}
                    </v-col>

                    <v-col
                      cols="3"
                      class="ma-auto text-center py-0"
                    >
                      {{ $moment(item.created_at, 'YYYY-MM-DD HH:mm:ss').format('D MMM YYYY hh:mm A') }}
                    </v-col>

                    <v-col
                      cols="2"
                      class="text-center py-0"
                    >
                      <setup-training-exams-dialog-marking
                        :attempt="item"
                        :exam="exam"
                        @updated="loadExamResult"
                      />
                    </v-col> 
                  </v-row>
                </v-card> 
              </div>
            </v-col>
  
            <v-col
              v-else
              cols="12"
            >
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="completedSearchInput"
                    placeholder="Filter by name"
                    append-icon="search"
                    label="Search Candidate"
                    hide-no-data
                    hide-details
                    hide-selected
                  />
                </v-col>
                <v-col cols="6">
                  <v-menu
                    v-model="completedDateMenu"
                    :close-on-content-click="true"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="completedDate"
                        label="Attempt Date"
                        prepend-icon="search"      
                        readonly
                        hide-details
                        clearable
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="completedDate"
                    />
                  </v-menu>
                </v-col>
              </v-row>

              <div class="scrollbar px-1 max-attempt-height">
                <span v-if="filteredCompletedAttempts.length<1">No Attempts</span>
                <v-card
                  v-for="(item,index) of filteredCompletedAttempts"
                  v-else
                  :key="index"
                  class="my-1"
                >
                  <v-row class="ml-1 full-width">
                    <v-col
                      class="font-weight-bold my-auto text-left py-0 name-ellipsis"
                      cols="4"
                    >
                      {{ item.employee.person.name }}
                    </v-col>

                    <v-col
                      cols="3"
                      class="ma-auto text-center py-0"
                      :class="{
                        'warning--text':!item.score
                      }"
                    >
                      {{ item.score ? item.score+'%':'Pending Marking' }}
                    </v-col>

                    <v-col
                      cols="3"
                      class="ma-auto text-center py-0"
                    >
                      {{ $moment(item.created_at, 'YYYY-MM-DD HH:mm:ss').format('D MMM YYYY hh:mm A') }}
                    </v-col>

                    <v-col
                      cols="2"
                      class="text-center py-0"
                    >
                      <setup-training-exams-dialog-result
                        :attempt="item" 
                        :exam="exam"
                      />
                    </v-col>
                  </v-row> 
                </v-card>
              </div>
            </v-col>
          </v-col>
        </v-row>
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="closeDialog()"
        >
          Close
        </v-btn>
      </v-card-actions> 
    </material-card>
  </v-dialog>
</template>

<script>
  export default { 
    components: {
      SetupTrainingExamsDialogMarking: () => import('@/components/setup/training/exams/DialogMarking'),
      SetupTrainingExamsDialogResult: () => import('@/components/setup/training/exams/DialogResult'),
    
    },
    inject: ['$validator'],
    props: {
      exam: {
        type: Object,
        required: true,
      },
    },
    
    data () {
      return {
        pendingSearchInput: '',
        completedSearchInput: '',
        loadingCompleted: false,
        dialog: false,
        resultTab: false,
        completedAttempts: [],
        pendingAttempts: [],
        pendingDateMenu: false,
        pendingDate: null,
        completedDateMenu: false,
        completedDate: null,
      }
    },

    computed: {
      filteredPendingAttempts () {
        let _this = this
        _this.pendingSearchInput = _this.pendingSearchInput.trim()
        let primaryFilter = this.pendingAttempts.filter(attempt => {
          return ((attempt.employee.person || {}).name || '').toLowerCase().indexOf(_this.pendingSearchInput.toLowerCase()) !== -1
        })

        let filteredDates = this.customFilterDate(primaryFilter, this.pendingDate)
        return filteredDates
      },

      filteredCompletedAttempts () {
        let _this = this
        _this.completedSearchInput = _this.completedSearchInput.trim()
        let primaryFilter = this.completedAttempts.filter(attempt => {
          return ((attempt.employee.person || {}).name || '').toLowerCase().indexOf(_this.completedSearchInput.toLowerCase()) !== -1
        })

        let filteredDates = this.customFilterDate(primaryFilter, this.completedDate)
        return filteredDates
      },
    },

    watch: {
      dialog (value) {
        if (!value) this.$resetData()
        this.loadExamResult()
      },
    },

    methods: {
      loadExamResult () {
        this.completedAttempts = []
        this.pendingAttempts = []

        this.$api.examAttempts().list(this.exam.id)
          .then(res => {
            let temp = []

            res.data.forEach(attempt => {
              if (attempt.score) {
                temp.push(attempt)               
                this.completedAttempts = _.orderBy(temp, ['employee.person.name', 'score'], ['asc', 'desc'])
              } else {
                this.pendingAttempts.push(attempt)
              }
            }) 

            if (this.pendingAttempts.length < 1 && this.completedAttempts.length > 1) {
              this.resultTab = true
            }

            this.loadingCompleted = true
          })
      },  
      closeDialog () {
        this.dialog = false
        this.loadingCompleted = false
      },
      customFilterDate (AttemptsList, Date) {
        if (!Date) return AttemptsList

        return AttemptsList.filter(attempt => {
          return attempt.created_at.includes(Date)
        })
      },
    },
  }
</script>

<style scoped>
.align-header-switch{
  display: flex;
  margin-top: 12px;
  height: 40px;
}
.full-width{
  width:100%
}
.name-ellipsis{
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.attempt-container-min-height{
  min-height:400px
}
.max-attempt-height{
  max-height:480px;
  overflow-y:scroll
}
.scrollbar::-webkit-scrollbar {
  width: 3px !important; 
}
.scrollbar::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px #e6e6e6; 
  border-radius: 10px;
}
.scrollbar::-webkit-scrollbar-thumb {
  background: grey; 
  border-radius: 10px;
  height: 2px;
}
.scrollbar::-webkit-scrollbar-thumb:hover {
  background:  #555; 
}
</style>
